import {
  InputWrapper,
  InputWrapperProps,
  TextArea,
  TextAreaProps,
} from "@certn/cascadia-react";
import { useField } from "formik";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useState } from "react";

interface Props extends TextAreaProps, InputWrapperProps {
  name: string;
  label: string;
  info?: React.ReactNode;
  testID: string;
  description?: string;
}

const parseEmails = (
  input: string,
  clientPortalBugFixAllowNewlineAtEndOfEmailListOrdering: boolean
) => {
  if (clientPortalBugFixAllowNewlineAtEndOfEmailListOrdering) {
    return input
      .trim()
      .split(",")
      .reduce<string[]>((prev, curr) => {
        return [...prev, ...curr.split(" ")];
      }, [])
      .filter(Boolean);
  } else {
    return input
      .split(",")
      .reduce<string[]>((prev, curr) => {
        return [...prev, ...curr.split(" ")];
      }, [])
      .filter(Boolean);
  }
};

export function EmailListField(props: Props) {
  const {
    name,
    span = "auto",
    testID = "email-list-area-field",
    label = "Recipient email(s)",
    description,
  } = props;
  const { clientPortalBugFixAllowNewlineAtEndOfEmailListOrdering } = useFlags();

  const [field, meta, helpers] = useField(name);
  const [text, setText] = useState(field.value.join(","));

  return (
    <InputWrapper span={span}>
      <TextArea
        name={name}
        errors={meta.touched && meta.error}
        label={label}
        onChange={(value: string) => {
          setText(value);
          helpers.setValue(
            parseEmails(
              value,
              clientPortalBugFixAllowNewlineAtEndOfEmailListOrdering
            )
          );
        }}
        onBlur={() => helpers.setTouched(true)}
        testID={testID}
        value={text}
        isRequired
        description={description}
      />
    </InputWrapper>
  );
}
